import React from 'react';
import { motion } from 'framer-motion';
import ObliqueIcon from '@/components/icons/ObliqueIcon';
import { Button } from './Button';

export function EmptyState({ 
    icon = 'inbox', 
    title = 'No Data Available', 
    description, 
    actionLabel, 
    onAction,
    className = '' 
}) {
    return (
        <motion.div 
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
            className={`flex flex-col items-center justify-center py-12 px-4 text-center ${className}`}
        >
            <div className="w-16 h-16 rounded-2xl bg-[var(--bg-subtle)] flex items-center justify-center text-[var(--text-tertiary)] mb-4">
                <ObliqueIcon name={icon} size={32} />
            </div>
            <h3 className="text-lg font-semibold text-[var(--text-primary)] mb-1">{title}</h3>
            {description && (
                <p className="text-[var(--text-secondary)] text-sm max-w-sm mx-auto mb-6">
                    {description}
                </p>
            )}
            {actionLabel && onAction && (
                <Button variant="outline" onClick={onAction}>
                    {actionLabel}
                </Button>
            )}
        </motion.div>
    );
}
